import type { NextPage, GetServerSideProps, GetStaticProps } from 'next'

import BoardModel from '@/modules/board'
import type { ListItem as IBoardListItem } from '@/modules/board'
import SEO from '@/modules/seo'
import MainPage from '@/components/pages/main'
import {ProjectModel, ProjectExtraModel} from "@/modules/project";
import {ProjectAssessmentList, SummaryItem, ListItem} from "@/modules/project/interface";

const getBoardItems = async (boardCategory: 'notice' | 'document'): Promise<IBoardListItem[]> => {
  const model = new BoardModel();
  model.category = boardCategory;
  const result = await model.getItems({ isIncludeContent: true, limit: 3});
  return result.items;
}

const assessmentItems2SummaryItems = (items: ProjectAssessmentList[]): SummaryItem[] => {
  let tempList: SummaryItem[] = [];
  for (let i = 0; i < items.length; i++) {
    let tempSummaryItem: SummaryItem = {
      idx: items[i].projectIdx,
      name: items[i].name,
      date: items[i].noticeDatetime
    };
    tempList.push(tempSummaryItem);
  }

  return tempList;
}

const draftItems2SummaryItems = (items: ListItem[]): SummaryItem[] => {
  let tempList: SummaryItem[] = [];
  for (let i = 0; i < items.length; i++) {
    let tempSummaryItem: SummaryItem = {
      idx: items[i].idx,
      name: items[i].name,
      date: items[i].createdAt
    };
    tempList.push(tempSummaryItem);
  }

  return tempList;
}

export const getServerSideProps: GetServerSideProps = async (context) => {
// export const getStaticProps: GetStaticProps = async (context) => {
  const projectModel = new ProjectModel();
  const projectExtraModel = new ProjectExtraModel();
  const noticeItems = await getBoardItems('notice');
  const documentItems = await getBoardItems('document');

  const publishedItems = await projectExtraModel.getItemsWithoutIdx({type: "assessment"});
  const draftItems = await projectModel.getItems({step: "draft", limit: 5})

  return {
    props: {
      publishedItems: assessmentItems2SummaryItems(publishedItems.items),
      draftItems: draftItems2SummaryItems(draftItems.items),
      noticeItems,
      documentItems
    },
    // revalidate: 60,
  }
}

interface IProps {
  publishedItems: SummaryItem[]
  draftItems: SummaryItem[]
  noticeItems: IBoardListItem[]
  documentItems: IBoardListItem[]
}


const Home: NextPage<IProps> = (props) => {
  const pageDescription = '경기도 환경영향평가 정보시스템 - 환경에 미칠 영향을 종합적으로 예측하고 평가하여 건전하고 지속가능한 개발을 조성합니다.';
  return (
    <>
      <SEO description={pageDescription} />
      <MainPage {...props} />
    </>
  )
}

export default Home
